"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputRadio = exports.InputRadioChoiceT = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const dompurify_1 = __importDefault(require("dompurify"));
const react_i18next_1 = require("react-i18next");
const RandomUtils_1 = require("chaire-lib-common/lib/utils/RandomUtils");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const surveyHelper = __importStar(require("evolution-common/lib/utils/helpers"));
const InputChoiceSorting_1 = require("./InputChoiceSorting");
const InputRadioChoice = (props) => {
    const id = `${props.id}__input-radio__${props.choice.value}`;
    const strValue = props.choice.value !== null && props.choice.value !== undefined
        ? props.choice.value.toString()
        : props.choice.value;
    const strLabel = surveyHelper.translateString(props.choice.label, props.i18n, props.interview, props.path, props.user);
    const inputRadioRef = react_1.default.createRef();
    const iconPath = props.choice.iconPath
        ? surveyHelper.parseString(props.choice.iconPath, props.interview, props.path)
        : null;
    return (react_1.default.createElement("div", { onClick: (e) => {
            props.onContainerClick(inputRadioRef, props.choice.value, e);
        }, className: `survey-question__input-radio-input-container${props.checked ? ' checked' : ''}` },
        react_1.default.createElement("div", { className: "label-input-container" },
            react_1.default.createElement("input", { type: "radio", id: id, name: props.id, className: 'input-radio', value: strValue, checked: props.checked, onChange: props.onRadioInputChange, onClick: props.onRadioClick, ref: inputRadioRef }),
            react_1.default.createElement("label", { htmlFor: id, onClick: props.onLabelClick },
                props.choice.icon && (react_1.default.createElement("span", null,
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: props.choice.icon, className: "faIconLeft", style: { margin: 'auto 0' } }))),
                iconPath && (react_1.default.createElement("span", null,
                    react_1.default.createElement("img", { src: iconPath, className: "faIconLeft", style: { height: props.iconSize, margin: '0 0.25em 0 0' }, alt: strLabel }))),
                react_1.default.createElement("span", { dangerouslySetInnerHTML: { __html: strLabel ? dompurify_1.default.sanitize(strLabel) : '' } }))),
        props.children));
};
exports.InputRadioChoiceT = (0, react_i18next_1.withTranslation)()(InputRadioChoice);
class InputRadio extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.customInputRef = react_1.default.createRef();
        this.customInputRadioRef = react_1.default.createRef();
        this.onContainerClick = (inputRadioRef, value, e) => {
            var _a;
            e.stopPropagation();
            const clickEvent = new MouseEvent('click', {
                view: window,
                bubbles: true,
                cancelable: false
            });
            if (inputRadioRef.current) {
                inputRadioRef.current.dispatchEvent(clickEvent);
            }
            else {
                // it means the clicked container is the custom one:
                (_a = this.customInputRadioRef.current) === null || _a === void 0 ? void 0 : _a.dispatchEvent(clickEvent);
            }
        };
        this.onRadioInputChange = (e) => {
            e.stopPropagation();
            if (this.props.customPath &&
                e.target.value !== this.props.widgetConfig.customChoice &&
                this.props.customValue !== null) {
                this.props.onValueChange(e, undefined);
                this.setState(() => ({ customValue: '' }));
            }
            else {
                this.props.onValueChange(e, this.props.customValue);
            }
        };
        this.onRadioClick = (e) => {
            e.stopPropagation();
        };
        this.onLabelClick = (e) => {
            e.stopPropagation();
        };
        this.onCustomInputBlur = (e) => {
            e.stopPropagation();
            this.props.onValueChange({ target: { value: this.props.widgetConfig.customChoice } }, e.target.value);
        };
        this.onCustomInputFocus = (e) => {
            var _a;
            e.stopPropagation();
            if (this.props.widgetConfig.customChoice !== this.props.value) {
                // trigger change on custom choice radio button:
                const clickEvent = new MouseEvent('click', {
                    view: window,
                    bubbles: true,
                    cancelable: false
                });
                (_a = this.customInputRadioRef.current) === null || _a === void 0 ? void 0 : _a.dispatchEvent(clickEvent);
            }
        };
        this.getColumnedChoices = (choiceInputs) => {
            if (this.props.widgetConfig.alignment === undefined &&
                this.props.widgetConfig.columns === undefined &&
                this.props.widgetConfig.rows === undefined &&
                (!this.props.widgetConfig.customAlignmentLengths ||
                    this.props.widgetConfig.customAlignmentLengths === undefined)) {
                return choiceInputs;
            }
            const widgetsByColumn = (0, InputChoiceSorting_1.sortByParameters)(choiceInputs, this.props.widgetConfig.alignment, this.props.widgetConfig.columns, this.props.widgetConfig.rows, this.props.widgetConfig.customAlignmentLengths);
            const columnedChoiceInputs = [];
            for (let i = 0, count = widgetsByColumn.length; i < count; i++) {
                const columnWidgets = widgetsByColumn[i];
                columnedChoiceInputs.push(react_1.default.createElement("div", { className: "survey-question__input-radio-group-column", key: i }, columnWidgets));
            }
            return columnedChoiceInputs;
        };
        this.state = {
            customValue: props.customValue || ''
        };
        this.customInputRef = react_1.default.createRef();
        this.customInputRadioRef = react_1.default.createRef();
    }
    render() {
        const widgetChoices = this.props.widgetConfig.choices;
        const choices = typeof widgetChoices === 'function' ? widgetChoices(this.props.interview, this.props.path) : widgetChoices;
        const iconSize = this.props.widgetConfig.iconSize || '2em';
        const parsedChoices = this.props.widgetConfig.shuffle === true
            ? (0, RandomUtils_1.shuffle)(choices, undefined, this.props.widgetConfig.seed)
            : choices;
        if (this.props.widgetConfig.addCustom) {
            if (!parsedChoices
                .map((choice) => {
                return choice.value;
            })
                .includes('custom'))
                parsedChoices.push({
                    value: 'custom',
                    label: {
                        fr: 'Autre',
                        en: 'Other'
                    }
                });
        }
        const choiceInputs = parsedChoices
            .filter((choice) => surveyHelper.parseBoolean(choice.conditional, this.props.interview, this.props.path, this.props.user))
            .filter((choice) => choice.hidden !== true)
            .map((choice) => (react_1.default.createElement(exports.InputRadioChoiceT, { choice: choice, id: `${this.props.id}_${choice.value}`, key: `${this.props.id}__${choice.value}__key`, interview: this.props.interview, path: this.props.path, user: this.props.user, checked: choice.value === this.props.value, iconSize: iconSize, onRadioClick: this.onRadioClick, onRadioInputChange: this.onRadioInputChange, onContainerClick: this.onContainerClick, onLabelClick: this.onLabelClick }, choice.value === this.props.widgetConfig.customChoice && (react_1.default.createElement("input", { type: "text", tabIndex: -1, autoComplete: "none", id: this.props.customId, name: this.props.customId, className: 'apptr__form-input input-custom apptr__input-string', value: this.state.customValue === null ? '' : this.state.customValue, onBlur: this.onCustomInputBlur, onFocus: this.onCustomInputFocus, onChange: (e) => this.setState({ customValue: e.target.value }), ref: this.customInputRef })))));
        // separate by columns if needed:
        const columnedChoiceInputs = this.getColumnedChoices(choiceInputs);
        return (react_1.default.createElement("div", { className: `survey-question__input-radio-group-container${this.props.widgetConfig.sameLine === false ? ' no-wrap' : ''}` }, columnedChoiceInputs));
    }
}
exports.InputRadio = InputRadio;
exports.default = (0, react_i18next_1.withTranslation)()(InputRadio);
//# sourceMappingURL=InputRadio.js.map